import React, { Component } from 'react'
import { Button, makeStyles } from '@material-ui/core';
import { PlayCircleOutline, GetAppOutlined, ContactsRounded } from '@material-ui/icons';
import DetailsTop from './DetailsTop';
import DetailsVideo from './DetailsVideo';
import DetailsBottom from './DetailsBottom';

// const useStyles = makeStyles((theme) => ({
//     button: {
//       margin: theme.spacing(1),
//       backgroundColor:'red'
//     },
//   }));
export default class Details extends Component {
    render() {
        const {details, dispatch} = this.props;
       
        return (
            <div className="details">
             <DetailsTop details={details} />
             <DetailsVideo details={details} />
             <DetailsBottom details={details} dispatch={dispatch}/>
            </div>
        )
    }
}
